import { useCallback } from "react";

import { useJitsu } from "@jitsu/react";

import { JitsuEvent } from "@/data/events/JitsuEvent";
import { useAppSelector } from "@/data/hooks";
import { getAssessmentId } from "@/data/task";
import {
  IPastAssessment,
  PreviewPastAssessmentCallback,
} from "@/data/templates";
import { useFeatureFlagsFragment } from "@/graphql/institution-selectors";
import { PastAssessmentsRoot } from "@/ui/templates/MyAssessments/PastAssessmentsRoot";
import { usePastAssessments } from "@/ui/templates/templatesHooks";

import { useShowPastAssessmentPreviewModal } from "./modals";
import { useOnDuplicatePastAssessment } from "./Preview/use-on-duplicate-past-assessment";

export const ConnectedMyAssessments = () => {
  const currentAssessmentId = useAppSelector(getAssessmentId);
  const onPreview = useOnPreview();
  const { loading, pastAssessments } = usePastAssessments(currentAssessmentId);

  const onDuplicatePastAssessment = useOnDuplicatePastAssessment();

  const features = useFeatureFlagsFragment();
  const examsFeatureEnabled = features?.exams === true;

  return (
    <PastAssessmentsRoot
      areExamsEnabled={examsFeatureEnabled}
      pastAssessments={pastAssessments ?? []}
      loading={loading}
      onDuplicate={onDuplicatePastAssessment}
      onPreview={onPreview}
    />
  );
};
const useOnPreview = (): PreviewPastAssessmentCallback => {
  const showPreviewModal = useShowPastAssessmentPreviewModal();
  const { track } = useJitsu();
  return useCallback(
    (pastAssessment: IPastAssessment, instructionSheetVersionId: string) => {
      showPreviewModal({
        pastAssessment: {
          ...pastAssessment,
          id: pastAssessment.assessmentId,
        },
        instructionSheetVersionId,
      });
      track(JitsuEvent.TEMPLATE_SHEET_PREVIEWED, {
        assessment_id: pastAssessment.assessmentId,
        assessment_name: pastAssessment.name,
        sheet_id: instructionSheetVersionId,
      });
    },
    [showPreviewModal, track]
  );
};
